import Service from "../Service";

const resource = "ExtCommercialMasterBudget/";

export default {
  pagination(filter, requestID) {
    return Service.post(resource + "pagination", filter, {
      params: { requestID: requestID },
    });
  },

  getById(id, requestID) {
    return Service.post(resource + "getById", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  getDetails(id, requestID) {
    return Service.post(resource + "getDetails", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID: requestID },
    });
  },

  lock(id, requestID) {
    return Service.post(resource + "lock", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  createVersion(id, requestID) {
    return Service.post(resource + "createVersion", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  cancel(id, requestID) {
    return Service.post(resource + "cancel", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  getProgrammingTracking(filter, requestID) {
    return Service.post(resource + "getProgrammingTracking", filter, {
      params: { requestID: requestID },
    });
  },

  getCustomerProgrammingLines(filter, requestID) {
    return Service.post(resource + "getCustomerProgrammingLines", filter, {
      params: { requestID: requestID },
    });
  },
};
